export default __webpack_public_path__ + "static/icon-30-1-8d6325df02f6447fe4ffcd753b409d07.png";